'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Category } from './categories-page-new';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { MdKeyboardArrowRight } from 'react-icons/md';

export function CategoryCard({ category }: { category: Category }) {
  if (!category?.image?.url) return null;

  return (
    <Link
      prefetch={false}
      href={ROUTES.CATEGORY({ slug: category.slug })}
      className="col-span-1 flex w-full items-center justify-between rounded-[8px] border border-border p-4 sm:p-5 lg:p-6"
    >
      <div className="flex items-center justify-start gap-4">
        <Image
          src={category?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(category?.image, category?.name)}
          width={0}
          height={0}
          className="max-h-12 min-h-12 min-w-12 max-w-12 shrink-0 rounded-[4px] bg-primary p-2"
        />
        <p className="line-clamp-1 whitespace-nowrap text-sm font-semibold">{category.name}</p>
      </div>
      <MdKeyboardArrowRight size={24} />
    </Link>
  );
}
